import loadable from "@loadable/component";
import React, { useState } from "react";

import Box from "@material-ui/core/Box";
import Avatar from "@material-ui/core/Avatar";

import useStyles from "@hooks/useStyles";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Chip from "@components/Global/Custom/Chip";
import Paper from "@material-ui/core/Paper";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";

import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import Tooltip from "@material-ui/core/Tooltip";

import Zoom from "@material-ui/core/Zoom";

import { adjective as proAdjective } from "@language/provider";

const PendingReviewItem = () => {
	const classes = useStyles("ClientReviews");

	return (
		<React.Fragment>
			<Paper variant="outlined" className={classes.paper}>
				<div className={classes.boxWrapper}>
					<div>
						<Box mb={2} fontSize={20} fontWeight={600}>
							Texas Lawn Masters
						</Box>
						<Box fontSize={15} color={"grey.600"}>
							17 years of experience
						</Box>
					</div>
				</div>

				<Box p={"0px 24px 24px"}>
					<List component="nav">
						<ListItem
							button
							disableGutters
							classes={{
								secondaryAction: classes.secondaryAction,
								container: classes.listItemContainer,
								root: classes.listItem,
							}}
						>
							<ListItemAvatar>
								<Avatar
									src="https://res.cloudinary.com/liaison-inc/image/upload/s--wyjS6Hef--/c_fill,f_webp,h_400,q_auto,w_400/v1/trustedcare/user-media/prod/approved/provider/655c251cb3ab416297883067/profile/l-V9oYXZ6/o.jpg"
									variant="rounded"
									//alt={provider.company_name}
									//title={provider.company_name}
									className={classes.avatar}
									imgProps={{
										loading: "lazy",
										decoding: "async",
									}}
								/>
							</ListItemAvatar>
							<ListItemText
								primary={"Haircut + Beard Trim"}
								secondary={"with Bob the Barber"}
								classes={{
									primary: classes.listPrimary,
									secondary: classes.listSecondary,
								}}
							/>
						</ListItem>
					</List>
					<Box mb={6}>
						<Divider light />
					</Box>

					<Button
						color="primary"
						disableElevation
						fullWidth
						variant="contained"
						size="large"
					>
						{`Rate ${proAdjective.singular}`}
					</Button>
				</Box>
			</Paper>
		</React.Fragment>
	);
};

PendingReviewItem.propTypes = {};
export default PendingReviewItem;
